import styled from 'styled-components';

export const DtoOrTvodButtonsStyled = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  width: 100%;

  button:first-child {
    margin-right: 10px;
  }
`;
